import SearchAgentSuite from './SearchAgentSuite';

export default SearchAgentSuite;